import { render, staticRenderFns } from "./FilterWallets.vue?vue&type=template&id=b8579ee8&scoped=true"
import script from "./FilterWallets.vue?vue&type=script&lang=ts"
export * from "./FilterWallets.vue?vue&type=script&lang=ts"
import style0 from "./FilterWallets.vue?vue&type=style&index=0&id=b8579ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8579ee8",
  null
  
)

export default component.exports